export function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6" data-testid={testId}>
      <div>
        <h1 className="text-2xl md:text-3xl font-semibold tracking-tight text-1">{title}</h1>
        {subtitle && <p className="text-2 text-sm mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-2">{actions}</div>}
    </div>
  );
}
